type Platform = 'instagram' | 'youtube' | 'snapchat' | 'tiktok';

const PLATFORMS: Record<Platform, Platform> = {
  instagram: 'instagram',
  tiktok: 'tiktok',
  snapchat: 'snapchat',
  youtube: 'youtube',
};

export { PLATFORMS };
export type { Platform };
